import React, { useState, useEffect } from 'react'
import { Container, CardGroup, Card, Button, Icon, Grid, GridColumn, Input, Confirm, Divider } from 'semantic-ui-react'

const MerchandiseReseller = ({ savedDict, markup, placeOrder, resellerBackClicked, hasPackages, disableDiscounts }) => {
    const [gameItems, setGameItems] = useState([])
    const [isSearching, setIsSearching] = useState(false)
    const [searchString, setSearchString] = useState('')
    const [showConfirmCheckout, setShowConfirmCheckout] = useState(false)
    const [confirmationCheckoutStr, setConfirmationCheckoutStr] = useState('')
    const [selectedItem, setSelectedItem] = useState(null)

    useEffect(() => {
        if (savedDict) {
            setGameItems(savedDict.gameItems || [])
        }
    }, [savedDict])

    const getPrice = (cost, discounted, discountRate) => {
        const adjustedMarkup = (discounted && !disableDiscounts) ? (Number(markup) - Number(discountRate)) : Number(markup)
        return Number(cost) + (adjustedMarkup / 100 * Number(cost))
    }

    const handleChangeSearchField = e => {
        const { value } = e.target
        if (value === '') {
            setIsSearching(false)
        } else {
            setIsSearching(true)
            setSearchString(value)
        }
    }

    const handleCardClicked = item => {
        setSelectedItem(item)
        setShowConfirmCheckout(true)
        setConfirmationCheckoutStr(`Proceed with: ${item.nameReseller.replace('Diamonds', '💎')} ($${roundUp2DP(getPrice(item.cost, item.isDiscountedReseller, item.discountRateReseller))})?`)
    }

    const handleCheckoutConfirm = () => {
        setShowConfirmCheckout(false)
        placeOrder(selectedItem)
    }

    const handleCheckoutCancel = () => {
        setShowConfirmCheckout(false)
    }

    const renderCards = () => {
        const data = isSearching ? gameItems.filter(item => item.nameReseller?.toLowerCase().includes(searchString.toLowerCase())) : gameItems
        if (!data || data.length === 0 || !data) return <div style={{ color: 'white' }}>No items available</div>
        const rows = []
        const doubleRechargeRows = []
        for (const [i, item] of data.entries()) {
            if (item.isHiddenReseller) continue
            const card = (
                <Card key={i} link raised stackable doubling image={item.image} header={{ content: item.nameReseller.replace('Diamonds', '💎'), style: { color: 'white' } }}
                        description={{ content: '$' + roundUp2DP(getPrice(item.cost, item.isDiscountedReseller, item.discountRateReseller)).toFixed(2), style: { color: 'white' } }} onClick={() => handleCardClicked(item)} style={{ backgroundColor: '#2a2b2c', color: 'white' }}/>
            )
            if (item.isDoubleRecharge) {
                doubleRechargeRows.push(card)
            } else {
                rows.push(card)
            }
        }
        return (
            <div>
                <CardGroup inverted style={{ marginTop: 20 }} centered doubling itemsPerRow={8}>{rows}</CardGroup>
                {doubleRechargeRows.length > 0 ? (
                    <div>
                        <Divider inverted style={{ marginTop: 30, marginBottom: 20 }}/>
                        <h4 style={{ color: 'white' }}>Double Recharge ⚡⚡</h4>
                        <CardGroup inverted style={{ marginTop: 20 }} centered doubling itemsPerRow={8}>{doubleRechargeRows}</CardGroup>
                    </div>
                ) : null}
            </div>
        )
    }

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            <Grid style={{ marginTop: 0 }}>
                <GridColumn floated='left' width={5}><h2 style={{ color: 'white' }}>{savedDict.name}</h2></GridColumn>
                <GridColumn width={6}><Input fluid action={{ icon: 'search' }} placeholder='Search product...' onChange={handleChangeSearchField} className="dark-theme-input"/></GridColumn>
                {hasPackages ? (
                    <GridColumn floated='right' width={5}>
                        <Button inverted floated='right' onClick={resellerBackClicked} color='blue'><Icon name='reply'/>Back</Button>
                    </GridColumn>
                ) : null}
            </Grid>
            {renderCards()}
            <Confirm inverted open={showConfirmCheckout} onCancel={handleCheckoutCancel} onConfirm={handleCheckoutConfirm} header='Confirmation' content={confirmationCheckoutStr} cancelButton='Cancel' confirmButton='Place Order'/>
        </Container>
    )
}

const roundUp2DP = num => {
    return Math.ceil(num * 100) / 100
}

export default MerchandiseReseller